import styled from "@emotion/styled";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { tokens } from "../../../theme";
import { NftPreviewCard } from "./NftPreviewCard";
import { useNavigate } from "react-router-dom";

const CollectibleWrapper = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-evenly",
  width: "100%",
  height: "380px",
  borderRadius: "16px",
  backgroundColor: "#ffffff",
  boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
  marginBottom: "30px",
  //   transform: "matrix(1, 0, 0, 1, 0, 0)",
});

const HeaderRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "98%",
});

const NftRow = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  width: "98%",
});

const SeeAllBox = styled(Box)({
  width: "88px",
  height: "34px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "0.75px solid #6A27EA",
  backgroundColor: "#F1EAFF",
  borderRadius: "7px",
  cursor: "pointer",
});

const CardWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "10px 10px 10px 10px",
  backgroundColor: theme.palette.secondary.dark,
  // width: "263px",
  height: "300px",
  borderRadius: 14,
  boxShadow: "0px 15px 30px rgba(118, 118, 118, 0.2)",
  marginRight: "20px",
  visibility: "hidden",
}));

export const Collectible = ({
  collectionName,
  collectionAddress,
  totalNfts,
  nfts,
  setInnerStepper,
  setSearchVar,
  setSearchShow,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const downXl = useMediaQuery(theme.breakpoints.down("xl"));
  const downMd = useMediaQuery(theme.breakpoints.down("md"));
  const [nftsToShow, setNftsToShow] = useState([0, 1, 2, 3, 4]);
  const navigate = useNavigate();

  const setNfts = () => {
    if (downMd) {
      setNftsToShow([0, 1, 2]);
    } else if (downXl) {
      setNftsToShow([0, 1, 2, 3]);
    } else {
      setNftsToShow([0, 1, 2, 3, 4]);
    }
  };

  useEffect(() => {
    setNfts();
  }, [downXl, downMd]);

  return (
    <CollectibleWrapper>
      <HeaderRow>
        <Typography
          variant="subtitle2"
          fontWeight="500"
          color={colors.black[900]}
        >
          {collectionName}
        </Typography>

        <SeeAllBox
          onClick={() => {
            setInnerStepper(collectionAddress);
            if (setSearchVar) setSearchVar("");
            if (setSearchShow) setSearchShow(false);
          }}
        >
          <Typography
            variant="fs12"
            fontWeight="500"
            color={colors.primary[500]}
          >
            See all ({totalNfts})
          </Typography>
        </SeeAllBox>
      </HeaderRow>
      <NftRow>
        {nftsToShow.map((nft, index) => {
          if (index <= nfts.length - 1) {
            return (
              <NftPreviewCard
                image={nfts[nft].image}
                collectionName={collectionName}
                tokenId={nfts[nft].tokenId}
                status={nfts[nft].status}
                onClickPreview={() => {
                  navigate(
                    `/collections/${nfts[nft]?.nftAddress}/${nfts[nft]?.tokenId}`
                  );
                }}
                key={nft}
              />
            );
          } else {
            return <CardWrapper></CardWrapper>;
          }
        })}
      </NftRow>
    </CollectibleWrapper>
  );
};
